export const BPM_RANGES = [
  { id: "all", label: "All BPM", min: 0, max: 999 },
  { id: "lt80", label: "< 80", min: 0, max: 79 },
  { id: "80-100", label: "80 – 100", min: 80, max: 100 },
  { id: "100-130", label: "100 – 130", min: 101, max: 130 },
  { id: "130-150", label: "130 – 150", min: 131, max: 150 },
  { id: "150-170", label: "150 – 170", min: 151, max: 170 },
  { id: "gt170", label: "170+", min: 171, max: 999 },
];

// Normalise key labels so "Dm" / "D min" / "D minor" all collapse into "Dm".
// Returns "" for garbage like "minor" (no tonic) so they don't pollute the filter row.
export const normalizeKey = (k) => {
  if (!k) return "";
  const s = String(k).trim();
  const m = s.match(/^([A-Ga-g])(#|b|♯|♭)?\s*(m|min|minor|maj|major|M)?\s*$/);
  if (!m) return "";
  const tonic = m[1].toUpperCase() + (m[2] ? m[2].replace("♯", "#").replace("♭", "b") : "");
  const quality = m[3] ? m[3].toLowerCase() : "";
  const minor = quality === "m" || quality === "min" || quality === "minor";
  return minor ? `${tonic}m` : tonic;
};

export const keyGroupLabel = (k) => (k.endsWith("m") ? `${k.slice(0, -1)} minor` : `${k} major`);
